import Vue from 'vue'
import { cloneDeep } from 'lodash-es'

import { EventBus } from '@/utils/event-bus'

import {
  SETTINGS_KEYS
} from '@/utils/keys'

const MIN_SAVE_DURATION = 500
let lastSave

export default {
  SET_PICTURE (state, { base64, mime, ext }) {
    state.picture = base64

    const version = base64 ? true : null

    Vue.set(state.settings.language, 'logo_asset_mime', mime)
    Vue.set(state.settings.language, 'logo_asset_ext', ext)
    Vue.set(state.settings.language, 'logo_asset_version', version)
  },
  SET_ERROR (state) {
    state.error = true
  },
  SET_SELF_UNINSTALLED (state, value) {
    state.selfUninstalled = value
  },

  SET_EVENTS (state, data) {
    state.events = data
  },

  SET_VAUTO (state, vAuto) {
    state.vAuto = vAuto
  },
  SET_VKRAKEN (state, vKraken) {
    state.vKraken = vKraken
  },
  SET_VFEATURES (state, vFeatures) {
    state.vFeatures = vFeatures
  },

  SET_MEMBER_SINCE (state, memberSince) {
    state.memberSince = memberSince
  },
  SET_SETUP (state, setup) {
    state.setup = setup
  },
  SET_SHOPOBJ (state, shopObj) {
    state.shopObj = shopObj
  },
  SET_PLAN (state, plan) {
    state.plan = plan
  },
  SET_TRIAL_ELIGIBILITY (state, eligibleForTrial) {
    state.eligibleForTrial = eligibleForTrial
  },

  SET_PREVIEW_ITEMS (state, previewItems) {
    state.previewItems = previewItems
  },
  UPDATE_PREVIEW_ITEMS (state, { type, item }) {
    state.previewItems[type] = item
  },

  NEXT_STEP (state) {
    state.currentSetupStep = state.currentSetupStep + 1
  },
  FINAL_STEP (state) {
    state.currentSetupStep = 4
  },

  SET_AMPTHEME (state, amptheme) {
    Vue.set(state, 'amptheme', amptheme)
    Vue.set(state.db, 'amptheme', cloneDeep(amptheme))
  },
  UPDATE_AMPTHEME (state, { key, value }) {
    if (key.includes('.')) {
      const arr = key.split('.')
      key = arr[0]

      value = {
        [arr[1]]: value
      }
    }

    Object.keys(value).forEach(k => {
      const val = value[k]

      if (!state.amptheme[key]) Vue.set(state.amptheme, key, {})

      Vue.set(state.amptheme[key], k, val)
    })
  },
  SET_SETTINGS (state, settings) {
    Vue.set(state, 'settings', settings)

    SETTINGS_KEYS.forEach(key => {
      const val = cloneDeep(settings[key])
      Vue.set(state.db, key, val)
    })
  },
  UPDATE_SETTINGS (state, { key, value }) {
    if (key.includes('.')) {
      const arr = key.split('.')
      if (arr.length > 2) throw new Error('Path is very deep', arr)

      key = arr[0]

      if (!state.settings[key]) {
        Vue.set(state.settings, key, {})
      }

      Vue.set(state.settings[key], arr[1], value)
    } else {
      Vue.set(state.settings, key, value)
    }
  },
  LOADING (state, value = true) {
    state.loading = value
  },
  SAVING (state, value = true) {
    if (value) {
      lastSave = Date.now()
      EventBus.$emit('toast:show', 'showSaving')
    } else {
      if (state.saving) {
        if (lastSave) {
          const diff = Date.now() - lastSave

          if (diff < MIN_SAVE_DURATION) {
            setTimeout(() => {
              EventBus.$emit('toast:show', 'showSaved')
            }, MIN_SAVE_DURATION - diff)
          } else {
            EventBus.$emit('toast:show', 'showSaved')
          }
        } else {
          EventBus.$emit('toast:show', 'showSaved')
        }
      }
    }

    state.saving = value
  },
  REVERT_CHANGES (state) {
    Object.keys(state.previewChange).forEach(key => {
      if (state.previewChange[key]) {
        const ref = SETTINGS_KEYS.includes(key) ? state.settings : state

        Vue.set(ref, key, cloneDeep(state.db[key]))
        state.previewChange[key] = false
      }
    })
  },
  UPDATE_LOGO_ASPECT_RATIO (state, logoAspectRatio) {
    state.logoAspectRatio = logoAspectRatio
  },
  UPDATE_COLLAPSE (state, { parent, item, highlight }) {
    Vue.set(state.collapseItems, parent, item)
    state.highlight = highlight
  },
  SWITCH_PREVIEW_TYPE (state, type) {
    state.currentPreviewType = type
  },
  UPDATE_PREVIEW_CHANGE (state, { type, changed }) {
    state.previewChange[type] = changed
  },
  UPDATE_PREVIEW_STATE (state, { type, updates }) {
    if (type === null) {
      state.preview = Object.assign({}, state.preview, updates)
    } else {
      state.preview[type] = Object.assign({}, state.preview[type], updates)
    }
  }
}
